export default __webpack_public_path__ + "static/media/bh2.0675e882.jpg";